import { Box, Flex, Icon } from "@nulogy/components";
import eventBuilderStyles from "domain/bryntum/eventBuilders.module.scss";
import DowntimeBlockDomain from "domain/DowntimeBlock";
import React from "react";
import Block from "./Block";
import BlockCellMenu from "./BlockCellMenu";
import BlockCellName from "./BlockCellName";
import BlockContainer from "./BlockContainer";
import HeaderWrapper from "./HeaderWrapper";
import Heading from "./Heading";
import Break from "./images/break.svg?react";
import LockIcon from "./LockIcon";

export default function DowntimeBlock({ blockData, readonly }) {
  const {
    block: { id, lockedOnSchedule, overlappingPlannedBreaks },
  } = blockData;

  const reasonDescription = DowntimeBlockDomain.reasonDescription(blockData.block);

  return (
    <BlockContainer className={`spec-downtime-${id}`} readonly={readonly}>
      <Block>
        <Flex flexDirection="column" height="100%" justifyContent="space-between">
          <BlockCellName>
            {lockedOnSchedule && (
              <LockIcon>
                <Icon icon="lock" size="16px" />
              </LockIcon>
            )}
            <HeaderWrapper>
              <Heading>{reasonDescription}</Heading>
            </HeaderWrapper>
          </BlockCellName>
          <Box height="x2">
            {overlappingPlannedBreaks?.length > 0 && (
              <Break className={`spec-breaks-indicator ${eventBuilderStyles.breakIcon}`} size="x2" />
            )}
          </Box>
        </Flex>
      </Block>
      <BlockCellMenu
        className={`b-fa b-fa-ellipsis-v js-block-menu spec-downtime-menu ${eventBuilderStyles.blockMenu}`}
      />
    </BlockContainer>
  );
}
